import { useState, useCallback } from "react";
import {
    Box,
    Button,
    Grid,
    InputLabel,
    TextField,
} from "@mui/material";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import api from "../../../services/QualityAssurance";

const AddVendor = ({ onSuccess }) => {
    const { admToken, user } = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        contactPersonName: "",
        address: "",
        companyName: "",
        companyPhoneNumber: "",
        companyEmail: "",
        contactPersonPhoneNumber: "",
        contactPersonEmail: "",
        schoolId: 0,
        id: 0
    });
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const fetchData = async () => {
        try {
            await api.getVendor(admToken);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const handleSubmit = useCallback(async () => {
        try {
            setLoading(true);
            const payload = {
                companyName: formData.companyName,
                companyPhoneNumber: formData.companyPhoneNumber,
                companyEmail: formData.companyEmail,
                address: formData.address,
                contactPersonName: formData.contactPersonName,
                contactPersonPhoneNumber: formData.contactPersonPhoneNumber,
                contactPersonEmail: formData.contactPersonEmail,
                schoolId: formData.schoolId,
                id: formData.schoolId
            };

            const res = await api.createVendor(admToken, payload);
            if (res.status === true) {
                toast.success(res.data.message || res.message);
                setFormData({
                    contactPersonName: "",
                    address: "",
                    companyName: "",
                    companyPhoneNumber: "",
                    companyEmail: "",
                    contactPersonPhoneNumber: "",
                    contactPersonEmail: "",
                    schoolId: 0,
                    id: 0
                });
                fetchData();
                if (onSuccess) onSuccess();
            } else {
                if (res.status && res.statusCode === 2) {
                    toast.success(res.data.message || res.message);
                    if (onSuccess) onSuccess();
                } else {
                    toast.error(res.data.message || res.message);
                }
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }, [admToken, formData, onSuccess]);

    return (
        <Box>
            <Grid container spacing={2}>
                <Grid item md={12} xs={12}>
                    <InputLabel sx={{ mb: 1 }}>Company Name</InputLabel>
                    <TextField
                        name="companyName"
                        fullWidth
                        size="small"
                        value={formData.companyName}
                        onChange={handleChange}
                        sx={{
                            "& .MuiOutlinedInput-root": { "& fieldset": { border: "1px solid #671E78" } },
                        }}
                    />
                </Grid>

                <Grid item md={12} xs={12}>
                    <InputLabel sx={{ mb: 1 }}>Company Address</InputLabel>
                    <TextField name="address" fullWidth size="small" value={formData.address} onChange={handleChange} />
                </Grid>

                <Grid item md={6} xs={12}>
                    <InputLabel sx={{ mb: 1 }}>Company PhoneNumber</InputLabel>
                    <TextField name="companyPhoneNumber" fullWidth size="small" value={formData.companyPhoneNumber} onChange={handleChange} />
                </Grid>
                <Grid item md={6} xs={12}>
                    <InputLabel sx={{ mb: 1 }}>Company Email</InputLabel>
                    <TextField name="companyEmail" fullWidth size="small" value={formData.companyEmail} onChange={handleChange} />
                </Grid>

                <Grid item md={12} xs={12}>
                    <InputLabel sx={{ mb: 1 }}>Contact Person</InputLabel>
                    <TextField name="contactPersonName" fullWidth size="small" value={formData.contactPersonName} onChange={handleChange} />
                </Grid>

                <Grid item md={6} xs={12}>
                    <InputLabel sx={{ mb: 1 }}>Contact Person PhoneNumber</InputLabel>
                    <TextField name="contactPersonPhoneNumber" fullWidth size="small" value={formData.contactPersonPhoneNumber} onChange={handleChange} />
                </Grid>
                <Grid item md={6} xs={12}>
                    <InputLabel sx={{ mb: 1 }}>Contact Person Email</InputLabel>
                    <TextField name="contactPersonEmail" fullWidth size="small" value={formData.contactPersonEmail} onChange={handleChange} />
                </Grid>

                <Grid item md={12} xs={12}>
                    <Box mt={5}>
                        <Button variant="contained" fullWidth sx={{ background: "#671e78", textTransform: "initial" }} onClick={handleSubmit} disabled={loading}>
                            {loading ? "Creating..." : "Create Vendor"}
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default AddVendor;
